import React from "react";
import { Phone, Mail, Clock, MapPin } from "lucide-react";

export default function Contact({ t, contact }) {
  const rows = [
    { icon: Phone, label: t.contact.phone_label, value: contact.phone_display, href: `tel:${contact.phone_tel}`, testid: "contact-phone" },
    { icon: Mail, label: t.contact.email_label, value: contact.email, href: `mailto:${contact.email}`, testid: "contact-email" },
    { icon: Clock, label: t.contact.hours_label, value: t.contact.hours_value, testid: "contact-hours" },
    { icon: MapPin, label: t.contact.area_label, value: t.contact.area_value, testid: "contact-area" },
  ];
  return (
    <section id="contact" className="bg-black text-white" data-testid="contact-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-28">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="text-xs font-bold tracking-[0.22em] text-[#E11D2E]">{t.contact.eyebrow}</div>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl mt-4 leading-[1]">
              {t.contact.title}
            </h2>
            <a
              href={`tel:${contact.phone_tel}`}
              className="block mt-8 font-display text-5xl md:text-6xl lg:text-7xl text-[#E11D2E] hover:text-white transition-colors"
              data-testid="contact-giant-phone"
            >
              {contact.phone_display}
            </a>
          </div>

          <div className="md:col-span-7 grid sm:grid-cols-2 gap-0 border-2 border-white">
            {rows.map((r, i) => {
              const Icon = r.icon;
              const inner = (
                <>
                  <Icon size={22} className="text-[#E11D2E]" />
                  <div className="mt-4 text-[11px] tracking-[0.22em] font-bold text-zinc-400 uppercase">
                    {r.label}
                  </div>
                  <div className="mt-1 font-display text-xl md:text-2xl">{r.value}</div>
                </>
              );
              const className =
                "block p-6 md:p-8 border-r-2 border-b-2 border-white hover:bg-white hover:text-black transition-colors last:border-r-0 sm:[&:nth-child(even)]:border-r-0 sm:[&:nth-last-child(-n+2)]:border-b-0";
              return r.href ? (
                <a key={i} href={r.href} className={className} data-testid={r.testid}>
                  {inner}
                </a>
              ) : (
                <div key={i} className={className} data-testid={r.testid}>
                  {inner}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
